"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportType = void 0;
var ImportType;
(function (ImportType) {
    ImportType["SFTP_SCHEDULED"] = "sftp-scheduled";
    ImportType["BROWSER_UPLOAD"] = "user-upload";
})(ImportType || (exports.ImportType = ImportType = {}));
